import _ShapeDiverErrors from "./ShapeDiverErrors";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdAssertUnreachable = sdAssertUnreachable;
const ShapeDiverErrors_1 = _ShapeDiverErrors;
function sdAssertUnreachable(_) {
  throw new ShapeDiverErrors_1.ShapeDiverError("Reached unreachable block");
}
//# sourceMappingURL=utils.js.map
export default exports;